import { Component, HostListener, Injector, OnInit } from '@angular/core';
import { Observable } from "rxjs";
import { CreateTaskComponent } from "../create-task.component";
import { EditTaskComponent } from "../edit-task.component";
import { TaskViewModel } from "../Model/TaskViewModel";
import { GroupBaseAdminPanelComponent } from "../../base-admin-panel/group-base-admin-panel.component";
import { GeozoneViewModel } from "../../Geozone/Model/GeozoneViewModel";
import { RouteViewModel } from "../../Routes/Model/RouteViewModel";
import { TasksService } from "../../../../services/tasks.service";
import { ObjectsService } from "../../../../services/objects.service";
import { RoutesService } from "../../../../services/routes.service";
import { ZoneService } from "../../../../services/zones.service";
import { MapObject, MapPoint } from "../../../shared/components/simple-map/c.component";
import { JSProxyService } from "../../../../services/jsproxy.service";
import { ObjectCreateViewModel } from "../../Objects/Models/ObjectViewModel";

@Component({
    selector: '[app-tasks]',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.css'],
    standalone: false
})
export class TasksComponent extends GroupBaseAdminPanelComponent implements OnInit {

  public trackers: ObjectCreateViewModel[] = [];
  public geozones: GeozoneViewModel[] = [];
  public routes: RouteViewModel[] = [];
  private from: number;
  private to: number;
  private tasksService: TasksService;
  private objectsService: ObjectsService;
  private routesService: RoutesService;
  private zonesService: ZoneService;
  private jsProxyService: JSProxyService;

  constructor(protected injector: Injector) {
    super(injector);
    this.tasksService = injector.get(TasksService);
    this.objectsService = injector.get(ObjectsService);
    this.routesService = injector.get(RoutesService);
    this.zonesService = injector.get(ZoneService);
    this.groupName = "TasksGroup";
    this.jsProxyService = injector.get(JSProxyService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.Refresh();
  }

  @HostListener('window:TimeInterval', ['$event'])
  onFilterApply(evt) {
    if (evt.detail) {
      this.from = evt.detail.from;
      this.to = evt.detail.till;
      this.refreshTasks();
    }
  }

  getObjects(): TaskViewModel[] {
    return this.objects as TaskViewModel[]
  }

  protected Refresh() {

    this.refreshTasks();
    this.objectsService.GetObjects().subscribe(trackers => {
      this.trackers = trackers;
    });
    this.objectsService.GetObjectGroups()
      .subscribe(trackers => {
        this.groupFilter.groups = trackers;
      });
    this.routesService.GetRoutes()
      .subscribe(routes => {
        this.routes = routes;
      });
    this.zonesService.GetZones()
      .subscribe(zones => {
        this.geozones = zones;
      });
  }

  private refreshTasks() {
    this.tasksService.GetTasks(this.to, this.from)
      .subscribe(drivers => {
        this.objects = drivers;
      });
  }

  public getRepeat(task: TaskViewModel) {
    switch (task.Repeat) {
      case 30:
        return this.translate.instant('Monthly');
      case 7:
        return this.translate.instant('Weekly');
      case 1:
        return this.translate.instant('Daily');
      case 0:
      default:
        return this.translate.instant('None');
    }
  }

  public getTarget(task: TaskViewModel) {
    if (task.RouteId) {
      return task.Route.Name;
    } else if (task.ZoneId) {
      return task.Zone.Name;
    } else {
      return task.Latitude + " " + task.Longitude;
    }
  }

  public showOnMap(task: TaskViewModel) {
    var mapDialog = this.jsProxyService.getComponent("CommonDialogs").openMapModal();

    var mapObject = new MapObject();
    if (task.ZoneId != undefined && task.ZoneId > 0)
      mapObject.geozoneId = task.ZoneId;
    else
      if (task.RouteId != undefined && task.RouteId > 0 && task.Route.Stops.length && task.Route.Stops[0].ZoneId)
        mapObject.geozoneId = task.Route.Stops[0].ZoneId;
      else
        mapObject.points.push(new MapPoint(task.Latitude, task.Longitude));

    mapDialog.ShowObjects([mapObject]);
  }

  public openCreateModal() {
    this.prepareModal(CreateTaskComponent);
    this.componentRef.instance.trackers = this.trackers;
    this.componentRef.instance.geozones = this.geozones;
    this.componentRef.instance.routes = this.routes;
    this.componentRef.instance.open(new TaskViewModel());
  }

  public openEditModal(key: TaskViewModel) {
    this.prepareModal(EditTaskComponent);
    this.componentRef.instance.trackers = this.trackers;
    this.componentRef.instance.geozones = this.geozones;
    this.componentRef.instance.routes = this.routes;
    this.componentRef.instance.open(key);
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.tasksService.DeleteTask(id);
  }

}
